export type CheckoutEvent = {
  eventDescription: string;
} & Event;
